import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { formatAvailabilityLabel } from "@/components/Dispatch/format";
import type { DriverRow } from "@/types/driver";
import ContextTile from "./ContextTile";
import { changedAt, NO_VALUE } from "./contextFormat";

/**
 * The calculated in-cab availability, with the heartbeat time it was derived from. Never logged in outranks Offline, as
 * in the driver view's availability column.
 */
export default function AvailabilityTile({ driver }: { driver: DriverRow }) {
  const value = availabilityLabel(driver);
  return (
    <ContextTile
      icon={<CheckCircleOutlineIcon sx={{ fontSize: 18 }} />}
      label="Availability"
      value={value || NO_VALUE}
      footnote={changedAt(driver.membershipAvailabilityUpdatedAt, "updated")}
    />
  );
}

/** The tile's label: Never logged in, then Offline, then the calculated availability. */
function availabilityLabel(driver: DriverRow): string {
  if (driver.neverLoggedIn) return formatAvailabilityLabel("neverLoggedIn");
  if (driver.offline) return "Offline";
  return formatAvailabilityLabel(driver.calculatedAvailability);
}
